module.exports = __webpack_public_path__ + "static/media/YF49_0.e05681c9.jpg";